import {
  SET_FETCH_STATUS,
  SET_FETCH_DEFAULTS,
  REQUEST_STATE,
  SET_FETCH_LOADING,
  LOAD_IO_STATE_BY_BOOK_ID,
  IMAGES_LOADING,
  AUTOFILL_FINISHED,
  CONVERT_FINISHED,
} from '../../action-types/entities/io';

import {
  getBookId,
  getDomain } from '../../helpers/getParams';
import {
  orderBy,
  configExist } from '../../helpers';

const config = require('./../../../services/clientconfig');

export const setFetchDefaults = () => ({
  type: SET_FETCH_DEFAULTS,
});

export const autofillFinished = status => ({
  type: AUTOFILL_FINISHED,
  status,
});

export const convertFinished = status => ({
  type: CONVERT_FINISHED,
  status,
});

export const setFetchLoading = isLoading => ({
  type: SET_FETCH_LOADING,
  isLoading,
});

export const setFetchStatus = status => ({
  type: SET_FETCH_STATUS,
  status,
});

export const requestState = () => ({
  type: REQUEST_STATE,
});

export const imagesLoading = status => ({
  type: IMAGES_LOADING,
  status,
});


export const loadIoStateByBookId = bookstate => ({
  type: LOAD_IO_STATE_BY_BOOK_ID,
  bookstate,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/io.js